export default __webpack_public_path__ + "static/media/frios.0ff94cb0.jpg";